// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ax-0";
export var orangeButton = "_ax-1";